<template>
  <v-container fluid class="down-top-padding">
    <base-breadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></base-breadcrumb>
    <base-card heading="Nova Avaliação">
      <!-- <form-exam action="add"></form-exam> -->
      <form-exam-database action="add"></form-exam-database>
    </base-card>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    page: {
      title: 'Nova Avaliação'
    },
    breadcrumbs: [
      {
        text: 'Início',
        disabled: false,
        to: '/'
      },
      {
        text: 'Avaliações',
        disabled: false,
        to: '/exam/list'
      },
      {
        text: 'Nova Avaliações',
        disabled: false,
        to: '/exam/add'
      }
    ]
  })
}
</script>
